export const LogLevel = {
    Verbose: 4,
    Errors: 4,
    Warnings: 3,
    Log: 2,
    Silent: 0,
};
function IsCustomLevel(l) {
    return typeof l === 'object';
}
export default class Logger {
    constructor(options = LogLevel.Silent) {
        this.options = options;
        this.opts = options === true
            ? { level: LogLevel.Verbose }
            : typeof options === "number" ? { level: options } : options;
    }
    log(...args) {
        if (IsCustomLevel(this.opts.level)
            ? this.opts.level.log
            : this.opts.level >= LogLevel.Log) {
            console.log(...args);
        }
    }
    warn(...args) {
        if (IsCustomLevel(this.opts.level)
            ? this.opts.level.warn
            : this.opts.level >= LogLevel.Warnings) {
            console.warn(...args);
        }
    }
    error(...args) {
        if (IsCustomLevel(this.opts.level)
            ? this.opts.level.error
            : this.opts.level >= LogLevel.Errors) {
            console.error(...args);
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@openreplay/tracker/lib/app/logger.js
// module id = 2646
// module chunks = 0